<template>
  <div class="masking-box" v-show="show">
      <div class="masking-son">
        <div class="close" @click="closeFun">x</div>
        <div class="puzzle-img">
          <img :src="src" style="width: 85%;height: 85%" @click="refreshFun">
         <!--  <van-icon name="replay" @click="refreshFun" class="flush" /> -->
        </div>
        <div style="border:1px solid #e0e0e0;margin-top: 10px">
          <van-cell-group>
            <van-field v-model="verificationCode" placeholder="请输入图形验证码" @input="graphCodeFun"/>
          </van-cell-group>
        </div>
      </div>
    </div>
</template>

<script>

import { verificationCode , checkoutVerificationCode} from '@/api/squeeze'
import { Toast,CellGroup, Field } from 'vant';

export default {
  name: 'GraphValidateCode',
  data(){
    return {
      verificationCode:'',
      show:false,
      phone:'',
      src:'',
    }
  },
  methods:{
    graphCodeFun(val){
       // console.log("图形验证码输入中",val);
      if(val.length == 4){
        checkoutVerificationCode({phone:this.phone,verificationCode:this.verificationCode}).then(res =>{
          Toast.success('验证成功');
          // 通知父组件发短信
          this.$emit('graph')
          this.show  = false;
        })
      }
    },
    init(phone){ //打开图形验证框
      this.show = true;
      this.phone = phone;
      verificationCode({phone}).then(res => {
        this.src = res.data
      })

    },
    closeFun(){// 关闭
      this.show  = false;
    },
    refreshFun(){ //刷新图形验证码
      verificationCode({phone:this.phone}).then(res => {
        this.src = res.data
      })

    }

  }
}
</script>

<style lang="scss" scoped>
  .masking-box {
      position:fixed;
      background:rgba(0,0,0,0.5);
      width: 100%;
      height: 100%;
      top:0;
      left:0;
      z-index: 2;
      display:flex;
      align-items:center;
      justify-content: center;
      .masking-son {
        background-color:white;
        width: 230px;
        padding:15px;
        box-sizing:border-box;
        height: 153px;
        border-radius:10px;
        position:relative;
        .close {
        position: absolute;
        right:-11px;
        top:-11px;
        width: 25px;
        height: 25px;
        border-radius:50%;
        background-color:#ac0606;
        text-align: center;
        line-height: 25px;
        color: white;
        font-weight: 600;
      }
        .puzzle-img {
          width: 200px;
          height: 69px;
          text-align: center;
          position:relative;
          .flush {
            position:absolute;
            top:0px;
            right:15px;
          }
          // text-align: right;
          // background-color:pink;
        }
      }
    }
</style>
